import { memo } from 'react';
import { AppText, Button, Modal, Row, Subheader, Theme } from '@streem/ui-react';
import appLogger from '../../../util/logging/app_logger';

const log = appLogger.extend('Lost Connection Modal');

export const LostConnectionModal = memo(function LostConnectionModal({
    expertIsOffline,
    lostUser,
    userWallSyncReconnectFailed,
    onReload,
}: {
    expertIsOffline: boolean;
    lostUser: boolean;
    userWallSyncReconnectFailed: boolean;
    onReload: () => Promise<void>;
}) {
    const isOpen = expertIsOffline || lostUser || userWallSyncReconnectFailed;

    if (isOpen) {
        log.info(
            `Displaying lost connection modal, reason expertIsOffline=${expertIsOffline} lostUser=${lostUser} userWallSyncReconnectFailed=${userWallSyncReconnectFailed}`,
        );
    }

    return (
        <Modal
            isOpen={isOpen}
            closeOnEscape={false}
            hideCloseButton
            styleOverride={{
                content: {
                    width: '36.25rem',
                    padding: Theme.spacing.l,
                },
            }}
        >
            <Subheader style={{ marginBottom: '1.5rem' }}>
                You've lost connection to Streem
            </Subheader>
            <AppText>Please refresh to reconnect.</AppText>
            <Row justifyContent={'flex-end'} width="100%" marginTop="2.25rem">
                <Button onClick={onReload} data-testid="refresh-modal-button">
                    Refresh
                </Button>
            </Row>
        </Modal>
    );
});
